import styleToCss from 'style-object-to-css-string'
import WebFont from 'webfontloader'
export default class {
  constructor (id) {
    this.stylesheet = this.createStylesheet(id)
  }

  static addLink (path, id) {
    let el = document.createElement('link')
    el.href = path
    el.rel = 'stylesheet'
    el.id = id
    el.type = 'text/css'
    document.getElementsByTagName('head')[0].appendChild(el)
    return el
  }

  static removeLink(id) {
    let el = document.getElementById(id)
    el.parentNode.removeChild(el)
  }

  createStylesheet (id) {
    let el = document.createElement('style')
    el.id = id
    el.type = 'text/css'
    document.getElementsByTagName('head')[0].appendChild(el)
    let sheet
    for (let i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].disabled) {
        continue
      }
      sheet = document.styleSheets[i]
    }
    return sheet
  }

  addRules (config) {

  }

  clear () {
    let numRules = this.stylesheet.cssRules.length
    while(this.stylesheet.cssRules.length > 0){
      this.stylesheet.deleteRule(0)
    }
  }

  addFonts (config) {
    try {
      let families = [config.headingFont.family, config.copyFont.family]
      WebFont.load({
        google: {
          families: families
        }
      })
      this.addRule(config.copyFont.selector, {fontFamily: config.copyFont.family})
      this.addRule(config.headingFont.selector, {fontFamily: config.headingFont.family})
    } catch (e) {
      throw new Error('Could not add fonts from config')
    }
  }

  addRule (selector, rules) {
    let idx = this.stylesheet.cssRules ? this.stylesheet.cssRules.length : 0
    this.stylesheet.insertRule(selector + ' {' + styleToCss(rules) + '}', idx)
  }
}
